import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Button } from "components/common/Buttons/MainButton";
import Spinner from "components/common/Spinner";
import React, { useEffect, useState } from "react";
import { endPoints } from "const/endPoints";
import { fetchWithToken } from "helpers/fetch";
import { PreviousResultsModal } from "./PreviousResultsModal";

export const ConfirmQuiz = ({ setConfirm, quiz }) => {
  const [attemptInfo, setAttemptInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showResultsModal, setShowResultsModal] = useState(false);

  useEffect(() => {
    const fetchAttemptInfo = async () => {
      try {
        if (!quiz?.id) {
          setLoading(false);
          return;
        }
        
        const response = await fetchWithToken(
          `${endPoints.get_quiz_attempts}/${quiz.id}`
        );
        
        if (response.status === 200) {
          const data = await response.json();
          setAttemptInfo(data);
        } else {
          // Fallback in case of error
          setAttemptInfo({
            attemptCount: 0,
            lastScore: null,
            canAttempt: true
          });
        }
        
      } catch (error) {
        console.error("Error fetching attempt info:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAttemptInfo();
  }, [quiz?.id]);

  const handleClick = () => {
    if (attemptInfo && attemptInfo.attemptCount >= 2) {
      return; // Don't allow starting if already 2 attempts
    }
    setConfirm(true);
  };

  if (loading) {
    return (
      <Box
        sx={{
          paddingTop: "2rem",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Spinner />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        paddingTop: "2rem",
      }}
    >
      {quiz ? (
        <>
          <Typography
            sx={{
              fontSize: "2rem",
              color: "#737373",
              textAlign: "center",
            }}
            variant="h4"
          >
            ¿Seguro que desea iniciar el Quiz?
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "1.2rem",
              color: "#737373",
              marginTop: "1rem",
              textAlign: "center",
            }}
          >
            Al momento de iniciar tendras {quiz.duration} minutos para terminar
            el Quiz.
          </Typography>
          
          {attemptInfo && (
            <Box
              sx={{
                textAlign: "center",
                marginTop: "1rem",
                padding: "1rem",
                backgroundColor: attemptInfo.attemptCount >= 2 ? "#fff3cd" : "#d4edda",
                border: `1px solid ${attemptInfo.attemptCount >= 2 ? "#ffeaa7" : "#c3e6cb"}`,
                borderRadius: "5px",
                maxWidth: "500px",
                margin: "1rem auto",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "1rem",
                  color: attemptInfo.attemptCount >= 2 ? "#856404" : "#155724",
                  fontWeight: "bold",
                }}
              >
                Intentos: {attemptInfo.attemptCount}/2
              </Typography>
              {attemptInfo.attemptCount >= 2 ? (
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "0.9rem",
                    color: "#856404",
                    marginTop: "0.5rem",
                  }}
                >
                  Has alcanzado el límite máximo de intentos para este quiz.
                </Typography>
              ) : (
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "0.9rem",
                    color: "#155724",
                    marginTop: "0.5rem",
                  }}
                >
                  Te quedan {2 - attemptInfo.attemptCount} intento(s) disponible(s).
                </Typography>
              )}
              {attemptInfo.lastScore && (
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "0.9rem",
                    color: "#495057",
                    marginTop: "0.5rem",
                  }}
                >
                  Último puntaje: {attemptInfo.lastScore}/20
                </Typography>
              )}
            </Box>
          )}
          
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "2rem",
              gap: "1rem",
            }}
          >
            <Button margin="0" text={"Volver atrás"} path={-1} />
            {attemptInfo?.attemptCount > 0 && (
              <Button
                margin="0"
                text={"Ver resultados"}
                click={() => setShowResultsModal(true)}
              />
            )}
            <Button
              margin="0"
              text={attemptInfo?.attemptCount >= 2 ? "Límite alcanzado" : "Iniciar el Quiz"}
              click={handleClick}
              disabled={attemptInfo?.attemptCount >= 2}
            />
          </Box>
        </>
      ) : (
        <Spinner />
      )}
      
      {/* Modal de resultados anteriores */}
      <PreviousResultsModal
        quizId={quiz?.id}
        visible={showResultsModal}
        onClose={() => setShowResultsModal(false)}
      />
    </Box>
  );
};
